import { z } from 'zod';

import { BrokerFiltersSchema } from './BrokerFiltersSchema';

export const BrokerRetrieveCriteriaSchema = z.object({
  filters: BrokerFiltersSchema.optional(),
  pagination: z
    .object({
      page: z.number().int().positive(),
      size: z.number().int().positive(),
    })
    .optional(),
});

export type BrokerRetrieveCriteria = z.infer<typeof BrokerRetrieveCriteriaSchema>;
